export default __webpack_public_path__ + "static/media/thumbnail.da5538b0.webp";